import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

export enum ContentUnavailableStyleEnum {
  DEFAULT,
  WHITE,
  WHITE_BLACK,
}

@Component({
  selector: 'app-content-unavailable',
  templateUrl: './content-unavailable.component.html',
  styleUrl: './content-unavailable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'nui-content-unavailable' },
})
export class ContentUnavailableComponent {
  public style = input<ContentUnavailableStyleEnum>(
    ContentUnavailableStyleEnum.DEFAULT
  );
  public readonly reload = output<void>();
  public readonly contentUnavailableStyleEnum = ContentUnavailableStyleEnum;

  public emitReloadEvent() {
    this.reload.emit();
  }
}
